import React, { useState } from 'react';
import './css/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    farmerType: 'individual'
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, you would send the form data to your backend here
    console.log('Form submitted:', formData);
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        farmerType: 'individual'
      });
    }, 3000);
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Growing Connections, Cultivating Solutions</h1>
          <p>Connect with our team of agriculture experts to modernize your farming practices and increase your yields</p>
        </div>
      </section>

      <div className="contact-container">
        <div className="contact-wrapper">
          {/* Left Column - Contact Form */}
          <div className="contact-form-section">
            <h2>Send Us a Message</h2>
            <p className="form-intro">We're here to help you overcome farming challenges with innovative solutions.</p>
            
            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h3>Thank You for Reaching Out!</h3>
                <p>Your message has been received. Our agriculture expert will contact you within 24 hours.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter your email"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="How can we help you?"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="farmerType">I am a/an:</label>
                  <select
                    id="farmerType"
                    name="farmerType"
                    value={formData.farmerType}
                    onChange={handleChange}
                  >
                    <option value="individual">Individual Farmer</option>
                    <option value="cooperative">Farming Cooperative</option>
                    <option value="agribusiness">Agribusiness</option>
                    <option value="student">Agriculture Student</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Your Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Tell us about your farming challenges, questions about our machinery, or partnership opportunities..."
                    rows="5"
                  ></textarea>
                </div>
                
                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            )}
          </div>
          
          {/* Right Column - Contact Info */}
          <div className="contact-info-section">
            <div className="contact-info-card">
              <h2>Get In Touch</h2>
              <p className="info-intro">We combine <strong>traditional farming wisdom</strong> with <strong>modern technology</strong> to provide the best solutions for your agricultural needs.</p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h3>Our Location</h3>
                    <p>Based in Rural Agricultural Hub<br />Tamil Nadu, India</p>
                    <p className="note">Serving farmers across Asia and beyond</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h3>Email Us</h3>
                    <p className="email-link">k.v.g.krish100@gmail.com</p>
                    <p className="email-link">gokul@greenowledge.onmicrosoft.com</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div>
                    <h3>Call Us</h3>
                    <p>India: +91-8675221100</p>
                    <p>Singapore: +65-88737903</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">⏰</div>
                  <div>
                    <h3>Business Hours</h3>
                    <p>Monday - Saturday: 8:00 AM - 8:00 PM</p>
                    <p>Sunday: 10:00 AM - 4:00 PM</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">📱</div>
                  <div>
                    <h3>Follow Us</h3>
                    <p>
                      <a 
                        href="https://www.instagram.com/green__knowledge/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="social-link"
                      >
                        Instagram: @green__knowledge
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="agriculture-quote">
                <div className="quote-icon">🌱</div>
                <p className="quote-text">
                  "The wise who can control themselves will control the world; others who cannot control themselves will not attain such greatness."
                </p>
                <p className="quote-author">- Tamil Thirukkural</p>
              </div>
              
              <div className="contact-note">
                <h3>Trust First Approach</h3>
                <p>As an agriculture family with 2 decades of experience, we understand your challenges. Our team of engineering and medical graduates is committed to providing viable, technology-driven solutions for your farming success.</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Mission Statement Section */}
        <div className="mission-section">
          <h2>Our Commitment to Farmers</h2>
          <div className="mission-points">
            <div className="mission-point">
              <div className="mission-icon">🤝</div>
              <h3>Creating Farmer-Consumer Relations</h3>
              <p>Building direct connections to increase your income by accessing international markets.</p>
            </div>
            <div className="mission-point">
              <div className="mission-icon">🤖</div>
              <h3>AI-Powered Farming Solutions</h3>
              <p>Implementing artificial intelligence to optimize yields and reduce disease risks.</p>
            </div>
            <div className="mission-point">
              <div className="mission-icon">💰</div>
              <h3>Cost Reduction</h3>
              <p>Providing affordable machinery rentals to minimize your operational costs.</p>
            </div>
            <div className="mission-point">
              <div className="mission-icon">🌍</div>
              <h3>Global Supply Chain</h3>
              <p>Connecting your products with international markets for better profitability.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;